import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgxActivityCardComponent } from '@go-modules/components/folder-view/activity-card/activity-card.component';
import { CardContainerModule } from '@go-modules/components/card-container/card-container.module';
import { NgxActivityListStatusModule } from '@go-modules/components/folder-view/activity-list-status/activity-list-status.module';
import { DotIndicatorModule } from '@go-modules/components/dot-indicator/dot-indicator.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { ActivityMenuModule } from '@go-modules/components/menus/activity-menu/activity-menu.module';
import { ActivityListDataSource } from '@go-modules/services/activity-list-datasource/activity-list.datasource';
import { CommentIndicatorModule } from '@go-modules/components/comment-indicator/comment-indicator.module';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { NgxActivityDueDateComponent } from '../activity-due-date/activity-due-date.component';
import { DetectTextTruncationDirective } from '@go-modules/directives/truncate/detect-text-truncation.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		CardContainerModule,
		NgxActivityListStatusModule,
		GoMaterialModule,
		DotIndicatorModule,
		ActivityMenuModule,
		CommentIndicatorModule,
		MenuModule,
		NgxActivityDueDateComponent,
		DetectTextTruncationDirective
	],
	declarations: [
		NgxActivityCardComponent
	],
	exports: [
		NgxActivityCardComponent
	],
	providers: [
		ActivityListDataSource
	]
})
export class NgxActivityCardModule {}
